export function getMonthDiff(from, to) {
    var fromYear = from.year();
    var toYear = to.year();
    var fromMonth = from.month();
    var toMonth = to.month();
    return (toYear - fromYear) * 12 + toMonth - fromMonth;
}
export function getMonthCalendarRows(value) {
    var _a, _b, _c;
    var weekStartDay = ((_c = (_a = value.localeData) === null || _a === void 0 ? void 0 : (_b = _a.call(value)).firstDayOfWeek) === null || _c === void 0 ? void 0 : _c.call(_b)) || 0;
    var monthStart = value.date(1);
    var monthEnd = value.endOf('month');
    var monthStartDay = monthStart.day();
    var monthEndDay = monthEnd.day();
    var weekEndDay = (6 + weekStartDay) % 7;
    var fisrtRowEndDate = monthStart.add((weekEndDay - monthStartDay + 7) % 7, 'day');
    var lastRowStartDate = monthEnd.subtract((monthEndDay - weekStartDay + 7) % 7, 'day');
    var fullWeekDays = lastRowStartDate.date() - fisrtRowEndDate.date() - 1;
    var fullWeeks = fullWeekDays / 7;
    return fullWeeks + 2;
}
